import { useEffect, useState } from "react";

export default function UseService() {
    const [searchQuery, setSearchQuery] = useState('')
    const serviceData = [
        {
            serviceid: 'Kafka-17df67d9',
            serviceName: 'Apache Kafka',
            quality: 'Rebuilding',
            plan: 'Startup-2',
            planSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            cloud: 'Amazon Web Services: us-east-2',
            cloudSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            time: '10 Seconds'
        },
        {
            serviceid: 'Kafka-17df67d9',
            serviceName: 'Apache Kafka',
            quality: 'Rebuilding',
            plan: 'Startup-2',
            planSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            cloud: 'Amazon Web Services: us-east-2',
            cloudSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            time: '10 Seconds'
        },
        {
            serviceid: 'Kafka-17df67d9',
            serviceName: 'Apache Kafka',
            quality: 'Rebuilding',
            plan: 'Startup-2',
            planSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            cloud: 'Amazon Web Services: us-east-2',
            cloudSpecs: '2 CPU/2GB RAM/ 90GB storage- 3-node high availability set',
            time: '10 Seconds'
        },

    ]
    const onTextChangeHandler = (val) => {
        setSearchQuery(val)
    };
    const cancelSearch = (val) => {
        setSearchQuery('')
    }
    const searchingFor = (searchQuery) => {
        return function (data) {
            return (
                data.serviceid.toLowerCase().includes(
                    searchQuery.toLowerCase(),
                )
                ||
                !searchQuery
            );
        };
    };


    return [{ serviceData , searchQuery, onTextChangeHandler, cancelSearch, searchingFor }]
}